import React, { useState } from 'react';
import "../Admin/assete/css/reviewadd.css";
import Adminheader from './Adminheader';
import {ReviewStatusApi} from "../service/Api";
import Sidebar from './Siderbar';

const Reviewadd = () => {

  
      const [formData, setFormData] = useState({
          name: '',
          review: '',
        });
        const [errorMessage, setErrorMessage] = useState('');
        const [successMessage, setSuccessMessage] = useState('');
      
        const handleChange = (e) => {
          const { id, value } = e.target;
        
        if (id === "name") {
          const onlyLettersAndDots = /^[A-Za-z\s.]+$/;
          if (!onlyLettersAndDots.test(value)) {
            setFormData({ ...formData, [id]: '' }); 
            return;
          } 
        }
        setFormData({ ...formData, [id]: value });
    };
      
        const handleSubmit = async () => {
          if (
              formData.name.trim() === '' ||
              formData.review.trim() === ''
            ) {
              
        return;
      }
      
                   try {       
                      console.log("data ",formData );
                   const response = await ReviewStatusApi(formData);
                   console.log('Form data saved:', response.data);
                   setSuccessMessage(' submitted successfully!');
                   setFormData({
                      name: '',
                     
                      review: ''
                   });
                   setTimeout(() => {
                      setSuccessMessage('');
                    }, 2000);
                  } catch (error) {
                      console.error('Error submitting form:', error);
                      setErrorMessage('Failed to submit career details.');
                    }
        };
      
  
  return (
   <>
  <div className='body-div'>
    <Adminheader/>
    <div className='container_dashboard'>
    <div className='index-content'>
      <Sidebar/>
      <div className='dashboard_main_div '>
      <div className='dashboard_div_4'>
      <div className='add_review_div'>
    <div className='add_review_div_1'>
        <h2>Add Review</h2>
    </div>
  </div>

  <div className='review_card_div'>
    <div className='review_card_main_div'>
        <div className='review_div_form'>
            <h2>Name:</h2>
            <input type='text' id="name" placeholder='Enter your Reviwer Name' value={formData.name} onChange={handleChange}  />
            <h2>Review:</h2>
            <textarea type="text" id="review" placeholder='Enter your Review' value={formData.review} onChange={handleChange}></textarea>
            <div className='review_btn'>
                <button onClick={handleSubmit}>Submit</button>
            </div>
            {errorMessage && <p className="error">{errorMessage}</p>}
          {successMessage && <p className="success">{successMessage}</p>}
        </div>
    </div>
  </div>

        </div>

        </div>

      </div>
      </div>

  </div>
   </>
  )
}

export default Reviewadd